















































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import Layout from "@/components/Layout.vue";
import Grid from "@/grid/Grid.vue";
import EmployerSelector from "@/components/EmployerSelector.vue";
import {
	ColDef,
	ColGroupDef,
	IServerSideDatasourceTyped,
	IServerSideGetRowsParamsTyped,
	ICellRendererParams,
} from "ag-grid-community";
import LinkFileFormat from "@/components/LinkFileFormat.vue";
import axios, { axiosStatic } from "@/utils/ApiUtils";
import { fileFormatLinkDelete, fileFormatList } from "@/constants/apiconstants";
import { PagedResult } from "@/grid/gridTypes";
import { FileFormat, DeleteFileRowParam } from "@/models/FileFormatRow";
import { TSelectLevel } from "@/components/employerSelectorTypes";
import { createNamespacedHelpers } from "vuex";
import Button from "@/form/Button.vue";
import FileFormatActionsRenderer from "@/grid/FileFormatActionsRenderer.vue";
import { toastErrorMessage, toastSuccessMessage } from "@/plugins/toasts";
import { parseErrorMessage } from "@/utils/ErrorUtils";

const { mapState } = createNamespacedHelpers("persistent");

@Component({
	components: {
		Layout,
		Grid,
		EmployerSelector,
		Button,
		LinkFileFormat,
	},
	computed: mapState([
		"selectedEntities",
		"employerHierarchy",
		"iressOperations",
		"sponsorPermissions",
	]),
})
export default class EmployerFileFormatPage
	extends Vue
	implements IServerSideDatasourceTyped
{
	private gridReady = false;
	private gridVMList: Vue[] = [];
	private selectedEntity: string | null = null;
	private showAddDialog = false;
	public $refs!: {
		gridEl: Grid;
	};

	private pageContext: TSelectLevel = "ALL";
	private errorMessage: string | null = null;

	private readonly columnDefs: (ColGroupDef | ColDef)[] = [
		{
			headerName: "File format name",
			field: "fileFormatName",
			resizable: true,
		},
		{
			headerName: "Entry level",
			field: "entryLevel",
			width: 30,
			resizable: true,
		},
		{
			headerName: "Action",
			cellRenderer: this.actionsRender,
			field: "deletable",
			width: 30,
			resizable: true,
			pinned: "right",
		},
	];

	private showLinkFileDialog(): void {
		if (!this.selectedEntity) {
			toastErrorMessage("No employer or parent is selected.");
		} else {
			this.showAddDialog = true;
		}
	}

	private onClose(): void {
		this.showAddDialog = false;
	}

	private onDone(): void {
		this.showAddDialog = false;
		this.reloadGrid();
	}

	actionsRender(params: ICellRendererParams): HTMLElement {
		const vm = new Vue({
			el: document.createElement("div"),
			render: (createElement) => {
				return createElement(FileFormatActionsRenderer, {
					props: {
						rowIndex: params.rowIndex,
						fileFormatId: params.data.id,
						deletable: params.data.deletable,
						rowFileFormatName: params.data.fileFormatName,
					},
					on: {
						clickDelete: this.onDeleteRow,
					},
				});
			},
		});
		this.gridVMList.push(vm);
		return vm.$el as HTMLElement;
	}

	private onDeleteRow(params: DeleteFileRowParam): void {
		axios
			.get<PagedResult<FileFormat>>(fileFormatLinkDelete(), {
				params: {
					fileFormatId: params.fileFormatId,
					selectEntity: this.selectedEntity,
				},
			})
			.then(() => {
				this.reloadGrid();
				toastSuccessMessage("A file format has been removed.");
			})
			.catch((rejected) => {
				toastErrorMessage(parseErrorMessage(rejected));
			});
	}

	@Watch("selectedEntities", { immediate: true })
	private getSelectedEntities(): void {
		if (this.$store.state.persistent.selectedEntities.length > 0) {
			this.selectedEntity =
				this.$store.state.persistent.selectedEntities[0];
		}
		this.retrieveFileFormats();
	}

	private onGridReady(): void {
		this.gridReady = true;
	}

	private retrieveFileFormats(): void {
		this.reloadGrid();
	}

	private reloadGrid(): void {
		this.gridReady = false;
		if (!this.$refs.gridEl) {
			return;
		}
		this.$refs.gridEl.reload();
		this.gridReady = true;
	}

	getRows(params: IServerSideGetRowsParamsTyped<FileFormat>): void {
		axios
			.get<PagedResult<FileFormat>>(fileFormatList(), {
				params: {
					grid: params.request,
					selectEntity: this.selectedEntity,
				},
			})
			.then((response) => {
				params.successCallback(response.data);
			})
			.catch((rejected) => {
				if (axiosStatic.isCancel(rejected)) {
					return;
				}
				params.failCallback();
				toastErrorMessage(parseErrorMessage(rejected));
			});
	}
}
